export function buildDirectionProperty(isRtl) {
    if (isRtl === true) {
        return { direction: 'rtl' };
    }
    else if (isRtl === false) {
        return { direction: 'ltr' };
    }
    /* if isRtl is undefined, this will allow for inheritance */
    return {};
}
